import intersection from 'lodash/intersection';

import { locales, primaryLocale } from './index';

const storageKey = 'i18n-locale';

const isValidLocale = function(locale) {
  return locales.includes(locale);
};

const getUserLocale = function() {
  const { language } = window.navigator;

  if (!language) {
    return;
  }

  const locale = language.split('-')[0];

  if (!isValidLocale(locale)) {
    return;
  }

  return locale;
};

const getUserPreferredLocale = function() {
  const { languages } = window.navigator;

  const common = intersection(languages, locales);

  return common[0];
};

const saveLocale = function(locale) {
  localStorage.setItem(storageKey, locale);
};

const getSavedLocale = function() {
  return localStorage.getItem(storageKey);
};

const initLocale = function() {
  const savedLocale = getSavedLocale();
  if (savedLocale) {
    return savedLocale;
  }

  const locale = getUserLocale() || getUserPreferredLocale() || primaryLocale;
  saveLocale(locale);
  return locale;
};

export { saveLocale, isValidLocale, initLocale };
